import { ActionInterface } from './MessageTypePayloads'
import { SenderOrRecipient, MessageInterface, MessageType } from '../MessageInterface'
import { createBaseMessage } from '../MessageCreation'

export enum CommandPayloadCommandType {
  NavigateTo = 'navigateTo',
  LoadPastMessages = 'loadPastMessages',
  ClearMessages = 'clearMessages',
  Analytics = 'analytics',
  Custom = 'custom',
  ScrollElement = 'scrollElement',
  ReplaceText = 'replaceText',
  ReplaceImage = 'replaceImage',
  OpenOrClose = 'openOrClose'
}
/**
 * @tsoaModel
 */
export interface CommandPayload {
  type: CommandPayloadCommandType
  payload: any
}

export function isCommandPayload(payload: any): payload is CommandPayload {
  return (
    payload !== undefined &&
    (payload as CommandPayload).type !== undefined &&
    Object.values(CommandPayloadCommandType).includes((payload as CommandPayload).type)
  )
}

export function createCommandMessage(
  to: SenderOrRecipient,
  from: SenderOrRecipient,
  type: CommandPayloadCommandType,
  payload: any
): MessageInterface {
  return createBaseMessage(MessageType.Command, { type: type, payload: payload }, to, from)
}
